module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-childcare-fr-FR@3x-5401385226723d27abca8fd8e1bfef68.png";